import { render } from "./GerarCartaPropostaInicio.vue?vue&type=template&id=0f1be1bc&scoped=true"
import script from "./GerarCartaPropostaInicio.vue?vue&type=script&lang=js"
export * from "./GerarCartaPropostaInicio.vue?vue&type=script&lang=js"

import "./GerarCartaPropostaInicio.vue?vue&type=style&index=0&id=0f1be1bc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f1be1bc"]])

export default __exports__